import React, {Component} from 'react';
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import DateFilter from "../common/dateFilter";
import Currency from "../common/currency";
import {getStationLiabilitySummary} from "./network/StationEODSummaryAPI";
import {getStationCode} from "../../network/NetworkUtil";
import Moment from "moment";
import AppLoader from "../common/appLoader";
import AppNotification from "../common/appNotification";
import Tag from "@amzn/meridian/tag";
import { publishCount } from "../../MetricUtility";
import { Metric, PROCESS_NAME} from "../common/constants"

const SummaryRow = (props) => {
    let isCurrency = props.isCurrency === true;
    let isVariance = props.isVariance;
    return (
        <Row widths={["grid-3", "grid-1"]}>
            <Text type="h100"> {props.name} </Text>
            {isCurrency ? <Currency isVariance={isVariance} amount={props.amount}/> :
                <Text>{props.value}</Text>}
        </Row>
    );
}

class StationEODSummary extends Component {
    initState = {
        cashSummary: {
            actualAmount: {
                unit: '',
                value: ''
            },
            expectedAmount: {
                unit: '',
                value: ''
            },
            shortExcessAmount: {
                unit: '',
                value: ''
            },
            count: ''
        },
        mposSummary: {
            amount: {
                unit: '',
                value: ''
            },
            count: ''
        },
        showLoader: true,
        hasError: false,
        showFilter: false
    };

    constructor(props) {
        super(props);
        this.state = this.initState;
        this.onDateUpdate = this.onDateUpdate.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
    }

    componentWillMount() {
        const stationCode = getStationCode();
        this.fetchLiability(stationCode, Moment());
    }

    onDateUpdate(date) {
        const stationCode = getStationCode();
        const selectedDate = Moment(date);
        this.fetchLiability(stationCode, selectedDate);
    }

    fetchLiability(stationCode, summaryDate) {
        let startTime = Moment(summaryDate).startOf('day').valueOf();
        let endTime = Moment(startTime).endOf('day').valueOf();
        this.setState({...this.initState, summaryDate: summaryDate});
        getStationLiabilitySummary({
            stationCode,
            startTime: startTime,
            endTime: endTime
        }).then(response => {
            if (response.status === 200) {
                this.setState({...response.data, hasError: false, errorMessage: "", showLoader: false});
                publishCount(PROCESS_NAME, Metric.GetStationEODSummary);
            } else {
                this.setState({
                    hasError: true,
                    errorMessage: "Failed to fetch station liability summary",
                    showLoader: false
                });
                publishCount(PROCESS_NAME, Metric.GetStationEODSummary_Failure);
                publishCount(PROCESS_NAME, Metric.GetStationEODSummary);
            }
        }).catch(error => {
            this.setState({
                hasError: true,
                errorMessage: "Failed to fetch station liability summary",
                showLoader: false
            });
            publishCount(PROCESS_NAME, Metric.GetStationEODSummary_Failure);
            publishCount(PROCESS_NAME, Metric.GetStationEODSummary);
        });
    }

    toggleFilter() {
        return this.setState({showFilter: !this.state.showFilter})
    }

    render() {
        const {cashSummary, mposSummary} = this.state;

        return (
            <Column>
                <Row>
                    {this.state.hasError && <AppNotification type="error" message={this.state.errorMessage}/>}
                </Row>
                <Row spacingInset="large large none large">
                    <Box>
                        <Link type="secondary" to="#" onClick={this.toggleFilter}>Options</Link>
                    </Box>
                    <Box>
                        <Tag key="date"
                             type="neutral">{Moment(this.state.summaryDate).local().format('MM/DD/YYYY')}</Tag>
                    </Box>
                </Row>

                {this.state.showFilter ?
                    <Row alignmentVertical="top" spacingInset="medium large" backgroundColor="secondary">
                    <Box>
                        <Text type="h100">Date</Text>
                        <DateFilter initialDate={this.state.summaryDate} onChangeDate={this.onDateUpdate}/>
                    </Box>
                </Row> : null
                }

                {this.state.showLoader ? <AppLoader/> : (!this.state.hasError && <Box>
                    <Column spacingInset="medium large large">
                        <Heading level={4} type="h400" alignment="left">Cash</Heading>

                        <Column spacing="small">
                            <SummaryRow name="Cash Shipments" value={cashSummary.count}/>
                            <SummaryRow name="Expected Cash at Station"
                                        amount={cashSummary.expectedAmount}
                                        isCurrency={true}/>
                            <SummaryRow name="Short/Excess Cash at Station"
                                        amount={cashSummary.shortExcessAmount}
                                        isCurrency={true}
                                        isVariance={true}/>
                            <SummaryRow name="Actual Cash at Station"
                                        amount={cashSummary.actualAmount}
                                        isCurrency={true}/>
                        </Column>
                    </Column>

                    <Column spacingInset="none large large">
                        <Heading level={4} type="h400" alignment="left">Digital</Heading>

                        <Column spacing="small">
                            <SummaryRow name="Digital Shipments" value={mposSummary.count}/>
                            <SummaryRow name="Digital Amount" amount={mposSummary.amount}
                                        isCurrency={true}/>
                        </Column>
                    </Column>
                </Box>)
                }
            </Column>
        );
    }
}

export default StationEODSummary;


// WEBPACK FOOTER //
// ./src/component/codSummary/StationEODSummary.js